/*

  u t i l s
  Utils

  :description:
  A file to store our utility functions.

*/

//
//  :code:
import { NODE_ID } from './statics'
//import { Buffer } from 'buffer'

//
//  :functions:
//  Generic functions in no specific order / structure.
//  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

//export const toBase64 = (value) => { return Buffer.from(value).toString("base64") }
//export const fromBase64 = (value) => { return Buffer.from(value, "base64").toString("utf-8") }

export const toBase64 = (value) => { return btoa(value) }
export const fromBase64 = (value) => { return atob(value) }

export const safeAddToDOM = (node) => {

  let globalNode = document.getElementById(NODE_ID)
  if (!globalNode) {
    globalNode = document.createElement("div")
    globalNode.setAttribute("id", NODE_ID)
    document.body.appendChild(globalNode)
  }
  globalNode.appendChild(node)
}
